import { Blueprint } from '../../blueprint.class';
import { ToolResult } from '../../types';

export interface ListAppliancesArgs {
	islandId?: string;
	category?: string;
	includeSystem?: boolean;
}

export interface ApplianceItem {
	id: string;
	sku: string;
	description: string;
	category: string;
	islandId: string;
	panelId: string;
}

const SYSTEM_CATEGORIES = ['vent', 'passthrough'];

export const listAppliancesTool = (blueprint: Blueprint, { islandId, category, includeSystem = false }: ListAppliancesArgs): ToolResult<ApplianceItem[]> => {
	const kitchen = blueprint.kitchens.getActiveVersion();
	if (!kitchen) return { success: false, error: 'No active kitchen found.' };

	const items: ApplianceItem[] = [];
	const categoryFilter = category ? category.toLowerCase() : null;

	// When islandId is not provided, iterate through all islands and include islandId for each appliance
	kitchen.design.islands.children.forEach((island) => {
		// Skip islands that don't match the filter (only when islandId is provided)
		if (islandId && island.id !== islandId) return;

		island.panels.children.forEach((panel) => {
			panel.panelItemGroups.children.forEach((group) => {
				group.items.children.forEach((panelItem) => {
					const { component } = panelItem.item;
					const compCategory = component.category;

					// Exclude system categories (vents, passthroughs) unless explicitly requested
					if (!includeSystem && SYSTEM_CATEGORIES.includes(compCategory.key)) return;

					// Filter by category if provided
					if (categoryFilter) {
						const matchesKey = compCategory.key.toLowerCase().includes(categoryFilter);
						const matchesDesc = compCategory.description.toLowerCase().includes(categoryFilter);
						// Also check component description for broader matching (e.g. "grill" in "36 inch grill")
						const matchesCompDesc = component.description.toLowerCase().includes(categoryFilter);

						if (!matchesKey && !matchesDesc && !matchesCompDesc) return;
					}

					items.push({
						id: panelItem.id,
						sku: component.sku,
						description: component.description,
						category: compCategory.description,
						islandId: island.id,
						panelId: panel.id
					});
				});
			});
		});
	});

	return {
		success: true,
		message: `Found ${items.length} items.`,
		data: items
	};
};
